import Drag from '../views/Thematic/Drag.vue';
// import List from '../views/Thematic/List.vue';
import Topic from '../views/Thematic/Topic.vue';
// import SpecialTop from '../views/Thematic/SpecialTop.vue';
import Picture from '../views/Thematic/Picture.vue';

let Thematic = [
  {
    path: 'Drag',
    name: '专题编辑',
    component: Drag
  },
  // {
  //   path: 'List',
  //   name: '模板列表',
  //   component: List
  // },
  {
    path: 'Topic',
    name: '专题列表',
    component: Topic
  },
  // {
  //   path: 'SpecialTop',
  //   name: '专题详情',
  //   component: SpecialTop
  // },
  {
    path: 'Picture',
    name: '图片模板',
    component: Picture
  }
];

export default Thematic;
